<!-- PILLAR_TOC -->
<document-pillar-toc-container
   *ngIf="tocType === 'PILLAR_TOC'"
  [pillars]="pillars"
  [newIndicatorDays]="newIndicatorDays">
</document-pillar-toc-container>
<!-- GROUP_MATRIX -->
<document-group-matrix-container
  *ngIf="tocType === 'GROUP_MATRIX'"
  [groups]="groups"
  [newIndicatorDays]="newIndicatorDays">
</document-group-matrix-container>
<!-- GROUP_LIST -->
<document-group-list-container
  *ngIf="tocType === 'GROUP_LIST'"
  [groups]="groups"
  [newIndicatorDays]="newIndicatorDays">
</document-group-list-container>
